
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic12Static as ObiHydraulic12StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-12-static.js';
 
 
 

 
 export const ObiHydraulic12Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-12-static',
   elementClass: ObiHydraulic12StaticElement,
   events: {
     
   }
  });
 
 